export { default as blendHex } from './functions/hex/blend';
export { default as collapseHex } from './functions/hex/collapse';
export { default as darkenHex } from './functions/hex/darken';
export { default as expandHex } from './functions/hex/expand';
export { default as generateHex } from './functions/hex/generate';
export { default as lightenHex } from './functions/hex/lighten';
export { default as randomHex } from './functions/hex/random';
export { default as hexToHsl } from './functions/hex/toHsl';
export { default as hexToRgb } from './functions/hex/toRgb';
export { default as hexTransition } from './functions/hex/transition';

//Take in an RGB object {'red': 0-255, 'green': 0-255, 'blue': 0-255}
export { default as rgbToCss } from './functions/rgb/toCss';
export { default as rgbToHex } from './functions/rgb/toHex';
export { default as rgbToHsl } from './functions/rgb/toHsl';

//Take in an HSL object {'lum': 0-1, 'sat': 0-1, 'hue': 0-359
export { default as hslToCss } from './functions/hsl/toCss';
export { default as hslToHex } from './functions/hsl/toHex';
export { default as hslToRgb } from './functions/hsl/toRgb';



// WEBPACK FOOTER //
// ./src/utilities/color/factories/ColorFactory.js